// Shared helpers for the Reports hub pages.
import api from "@/lib/api";

export const FREQ_LABEL = { hourly: "Hourly", daily: "Daily", weekly: "Weekly", monthly: "Monthly", cron: "Cron expression" };
export const DOW = [["mon", "Monday"], ["tue", "Tuesday"], ["wed", "Wednesday"], ["thu", "Thursday"],
  ["fri", "Friday"], ["sat", "Saturday"], ["sun", "Sunday"]];
export const FORMAT_LABEL = { inline: "Table in the email", csv: "CSV attachment", pdf: "PDF attachment" };
export const SFTP_FORMAT_LABEL = { csv: "CSV file", pdf: "PDF file" };
export const CHANNEL_LABEL = { email: "Email", sftp: "SFTP upload" };
export const formatLabel = (fmt, channel) => (channel === "sftp" ? SFTP_FORMAT_LABEL[fmt] || fmt?.toUpperCase() : FORMAT_LABEL[fmt] || fmt);
export const fmtBytes = (n) => (!n && n !== 0 ? "—" : n < 1024 ? `${n} B` : n < 1048576 ? `${(n / 1024).toFixed(1)} KB` : `${(n / 1048576).toFixed(1)} MB`);

// Month strings relative to today: "-2m" → two months ago as YYYY-MM.
function relMonth(spec) {
  const m = /^(-?\d+)m$/.exec(spec || "");
  if (!m) return spec || "";
  const d = new Date();
  d.setDate(1);
  d.setMonth(d.getMonth() + parseInt(m[1], 10));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

// Day strings relative to today: "-6d" → six days ago as YYYY-MM-DD.
function relDate(spec) {
  const m = /^(-?\d+)d$/.exec(spec || "");
  if (!m) return spec || "";
  const d = new Date();
  d.setDate(d.getDate() + parseInt(m[1], 10));
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function defaultParams(report) {
  const out = {};
  (report?.params || []).forEach((p) => {
    if (p.type === "month") out[p.key] = relMonth(p.default);
    else if (p.type === "date") out[p.key] = relDate(p.default);
    else if (p.type === "bool") out[p.key] = p.default ?? false;
    else if (p.default !== undefined) out[p.key] = p.default;
    else out[p.key] = "";
  });
  return out;
}

// A field hidden by a `when` rule (e.g. custom dates only when preset is blank).
export function paramVisible(p, params) {
  if (!p.when) return true;
  return Object.entries(p.when).every(([k, v]) => (params[k] ?? "") === v);
}

export function missingRequired(report, params) {
  return (report?.params || []).filter((p) => p.required && paramVisible(p, params) && !String(params[p.key] ?? "").trim());
}

export function describeParams(report, params) {
  return (report?.params || [])
    .filter((p) => paramVisible(p, params) && String(params?.[p.key] ?? "") !== "" && params?.[p.key] !== false)
    .map((p) => {
      const v = params[p.key];
      if (p.type === "bool") return p.label;
      const opt = (p.options || []).find((o) => o.value === v);
      return `${p.label}: ${opt ? opt.label : v}`;
    });
}

export const runReport = (report_key, params) => api.post("/report-hub/run", { report_key, params });
export const downloadReport = (report_key, params, format) =>
  api.post("/report-hub/download", { report_key, params, format }, { responseType: "blob" });
